import { useGetDataVaultArenasQuery } from "~/graphql/supergraphHooks";
import { UseArenasDataReturn } from "../types";
import { transformArenasToGridRows } from "../utils/dataTransformers";

export function useArenasData(): UseArenasDataReturn {
  const { data, loading, error, refetch } = useGetDataVaultArenasQuery({
    variables: {
      includeAdminArena: false,
      applicationContext: undefined,
    },
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  const arenas = data?.arenas?.edges
    ? transformArenasToGridRows(data.arenas.edges.map((edge) => edge.node))
    : [];

  const handleRefetch = () => {
    void refetch({
      includeAdminArena: false,
      applicationContext: undefined,
    });
  };

  return {
    arenas,
    loading,
    error,
    refetch: handleRefetch,
  };
}
